import Button from "@scripts/react/components/Button";
import React from "react";
import { TooltipContainer } from "@scripts/react/components/Tooltip";
import { useMobile } from "@/hooks/useMobile";

// Sub-component
interface PlayPauseButtonProps {
    isPlaying: boolean;
    onClick: () => void;
    disabled?: boolean;
}
export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
    isPlaying,
    onClick,
    disabled = false
}) => {
    const isMobile = useMobile();

    return (
        <TooltipContainer
            type="titleOnly"
            title={
                <div>
                    {isPlaying ? "Pause" : "Play"}
                    <span className="hotkey dark ml-2">Space</span>
                </div>
            }
            disabled={isMobile}
            customButton={
                <Button
                    size="large"
                    type="ghost"
                    className={disabled ? "cursor-not-allowed opacity-50" : ""}
                    shape="circle"
                    onClick={onClick}
                    disabled={disabled}
                >
                    {isPlaying ? <i className="fas fa-pause" /> : <i className="fas fa-play" />}
                </Button>
            }
        />
    );
};
